module.exports = __webpack_public_path__ + "static/shuyun-f83bf792c84c1cec5ea7ee0de5f7dfe7.png";